import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
import { SessionEventArgs } from "./Exports";
/**
 * Defines payload for any Service message event
 * Added in version 1.9.0
 */

export var ServiceEventArgs = /*#__PURE__*/function (_SessionEventArgs) {
  _inherits(ServiceEventArgs, _SessionEventArgs);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} json - json payload of the USP message.
   */
  function ServiceEventArgs(json, name, sessionId) {
    var _this;

    _classCallCheck(this, ServiceEventArgs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ServiceEventArgs).call(this, sessionId));
    _this.privJsonResult = json;
    _this.privEventName = name;
    return _this;
  }

  _createClass(ServiceEventArgs, [{
    key: "jsonString",
    get: function get() {
      return this.privJsonResult;
    }
  }, {
    key: "eventName",
    get: function get() {
      return this.privEventName;
    }
  }]);

  return ServiceEventArgs;
}(SessionEventArgs);